"use client";

// Last-resort boundary for errors thrown in the root layout itself, where the portal boundary
// cannot render. It must provide its own <html>/<body>. Same rule as elsewhere: a controlled
// message plus the digest, never a stack trace or business data.
export default function GlobalError({ error, retry }: { error: Error & { digest?: string }; retry: () => void }) {
  return (
    <html lang="de" className="h-full">
      <body className="min-h-full bg-slate-950 text-slate-100 antialiased">
        <main className="mx-auto max-w-2xl px-6 py-16">
          <h1 className="text-2xl font-semibold">JARVIS ist vorübergehend nicht verfügbar</h1>
          <p className="mt-3 text-sm leading-6 text-slate-400">
            Die Anwendung konnte nicht geladen werden. Es wurde nichts gespeichert, versendet oder freigegeben.
          </p>
          {error.digest && (
            <p className="mt-4 text-xs text-slate-500">
              Fehlerkennung: <code className="rounded bg-slate-900 px-2 py-1 font-mono text-slate-300">{error.digest}</code>
            </p>
          )}
          <button
            type="button"
            onClick={() => retry()}
            className="mt-6 inline-flex min-h-11 items-center rounded-lg bg-brand-500/15 px-4 text-sm font-medium text-brand-200 transition hover:bg-brand-500/25"
          >
            Erneut versuchen
          </button>
        </main>
      </body>
    </html>
  );
}
